import React from "react";
import { Check, X } from "lucide-react";

const cols = [
    {
        title: "DIY Smart Home",
        tag: "Do-it-yourself",
        highlight: false,
        rows: [
            { ok: false, t: "Multiple apps and hubs" },
            { ok: false, t: "Difficult setup" },
            { ok: false, t: "Compatibility problems" },
            { ok: false, t: "Self-installation" },
            { ok: false, t: "Limited support" },
        ],
    },
    {
        title: "GoSmartNest",
        tag: "Recommended",
        highlight: true,
        rows: [
            { ok: true, t: "One connected experience" },
            { ok: true, t: "Professional installation" },
            { ok: true, t: "Works with existing appliances" },
            { ok: true, t: "Starts at ₹17,999" },
            { ok: true, t: "1-year included + extendable warranty" },
            { ok: true, t: "Expert support" },
        ],
    },
    {
        title: "Luxury Automation",
        tag: "Premium brands",
        highlight: false,
        rows: [
            { ok: false, t: "Extremely expensive" },
            { ok: false, t: "Often complex" },
            { ok: false, t: "Expensive upgrades" },
            { ok: false, t: "High installation cost" },
        ],
    },
];

export default function WhyGoSmartNest() {
    return (
        <section className="max-w-7xl mx-auto px-5 sm:px-8 py-24" data-testid="why-gosmartnest">
            <div className="max-w-2xl">
                <div className="text-xs tracking-[0.2em] uppercase text-[#1BB6F0] font-semibold">Why GoSmartNest</div>
                <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#1B2E7A] leading-tight">
                    The smart middle ground.
                </h2>
                <p className="mt-4 text-slate-600 max-w-lg">
                    Premium experience without unnecessary premium pricing — and none of the DIY headaches.
                </p>
            </div>

            <div className="mt-12 grid grid-cols-1 lg:grid-cols-3 gap-5">
                {cols.map((c, i) => (
                    <div
                        key={i}
                        data-testid={`compare-col-${i}`}
                        className={`rounded-3xl p-8 border transition-transform ${
                            c.highlight
                                ? "bg-[#0B1440] text-white border-[#1BB6F0] lg:-translate-y-3 shadow-2xl shadow-[#1B2E7A]/30"
                                : "bg-white border-slate-200"
                        }`}
                    >
                        <div className={`text-[11px] tracking-[0.2em] uppercase font-semibold ${c.highlight ? "text-[#1BB6F0]" : "text-slate-500"}`}>{c.tag}</div>
                        <div className={`mt-2 text-2xl font-semibold ${c.highlight ? "text-white" : "text-[#1B2E7A]"}`}>{c.title}</div>
                        <ul className="mt-6 space-y-3">
                            {c.rows.map((r, j) => (
                                <li key={j} className="flex items-start gap-3 text-sm">
                                    <span className={`mt-0.5 w-5 h-5 rounded-full flex items-center justify-center ${r.ok ? "bg-[#1BB6F0] text-white" : c.highlight ? "bg-white/10 text-white/50" : "bg-slate-100 text-slate-400"}`}>
                                        {r.ok ? <Check className="w-3 h-3" /> : <X className="w-3 h-3" />}
                                    </span>
                                    <span className={c.highlight ? "text-white/90" : "text-slate-700"}>{r.t}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </section>
    );
}
